// All static content for the Winfield Token landing page.
// Each user-facing string is bilingual: { en, sr }.
// Use the `useT()` hook from `@/i18n/LanguageContext` to resolve values.

export const LINKS = {
  twitter: "https://x.com/winfieldtoken",
  telegram: "https://t.me/winfieldtoken",
  discord: "https://discord.gg/winfieldtoken",
  instagram: "https://www.instagram.com/winfieldtoken",
  email: "mailto:winfieldtoken@gmail.com",
};

export const NAV_ITEMS = [
  { id: "token", href: "#token", label: { en: "What is $WINN", sr: "Šta je $WINN" } },
  { id: "partneri", href: "#partneri", label: { en: "Partners", sr: "Partneri" } },
  { id: "paketi", href: "#paketi", label: { en: "Packages", sr: "Paketi" } },
  { id: "kako", href: "#kako", label: { en: "How it works", sr: "Kako funkcioniše" } },
  { id: "roadmap", href: "#roadmap", label: { en: "Roadmap", sr: "Plan razvoja" } },
  { id: "faq", href: "#faq", label: { en: "FAQ", sr: "FAQ" } },
];

// ---------- Hero ----------
export const HERO = {
  badge: { en: "Pre-launch · Limited", sr: "Pre-launch · Ograničeno" },
  badgeSecondary: { en: "Winfield Pre-Launch · $WINN", sr: "Winfield Pre-Launch · $WINN" },
  // headline lines split for typography control
  headline: {
    en: ["Your yield.", "Your stay.", "Your legacy."],
    sr: ["Vaš prinos.", "Vaš boravak.", "Vaše nasleđe."],
  },
  // word in italic at the end of headline
  italicIndex: 2,
  subhead: {
    en: "$WINN is a security digital token that delivers annual rental yield, priority booking rights and Cooperative membership — for 99 years.",
    sr: "$WINN je security digitalni token koji vam donosi godišnji prinos od rentiranja, pravo prioritetne rezervacije i članstvo u Zadruzi — za 99 godina.",
  },
  ctaPrimary: { en: "Reserve your spot →", sr: "Rezervišite mesto →" },
  ctaSecondary: { en: "What is $WINN", sr: "Šta je $WINN" },
  tokenCardLabel: { en: "$WINN · Security Token · Pending KHoV RS approval", sr: "$WINN · Security Token · Čeka odobrenje KHoV RS" },
  tokenCardTag: { en: "Security Token · Pre-launch", sr: "Security Token · Pre-launch" },
};

export const HERO_STATS = [
  { value: { en: "99", sr: "99" }, label: { en: "Years of rights", sr: "Godina prava" } },
  { value: { en: "From 4", sr: "Od 4" }, label: { en: "Weeks per year", sr: "Nedelje godišnje" } },
  { value: { en: "396", sr: "396" }, label: { en: "Tokens per package", sr: "Tokena po paketu" } },
  { value: { en: "Up to 70%", sr: "Do 70%" }, label: { en: "Rental yield", sr: "Prinos od rentiranja" } },
  { value: { en: "€0", sr: "€0" }, label: { en: "Acquisition costs", sr: "Troškova sticanja" } },
  { value: { en: "€0", sr: "€0" }, label: { en: "Monthly costs", sr: "Mesečnih troškova" } },
];

// ---------- Ticker ----------
export const TICKER_ITEMS = [
  { en: "$WINN Security Token", sr: "$WINN Security Token" },
  { en: "Zlatibor — Serbia", sr: "Zlatibor — Srbija" },
  { en: "Monte Casa I", sr: "Monte Casa I" },
  { en: "99-Year Rights", sr: "Prava na 99 godina" },
  { en: "Subject to KHoV RS approval", sr: "Uslovljeno odobrenjem KHoV RS" },
  { en: "Your yield · Your stay · Your legacy", sr: "Vaš prinos · Vaš boravak · Vaše nasleđe" },
];

// ---------- Benefits (What is $WINN) ----------
export const BENEFITS_INTRO = {
  eyebrow: { en: "What is $WINN", sr: "Šta je $WINN" },
  title: { en: "What do you get with $WINN?", sr: "Šta dobijate $WINN tokenom?" },
  description: {
    en: "$WINN is a security/investment digital token subject to approval by the Securities Commission of the Republic of Serbia (KHoV). It is not property ownership — it is a bundle of property rights delivering yield and stay benefit for 99 years.",
    sr: "$WINN je security/investicioni digitalni token uslovljen odobrenjem Komisije za hartije od vrednosti Republike Srbije (KHoV). Nije pravo vlasništva nad nekretninom — već skup imovinskih prava koja vam donose prinos i benefit boravka kroz 99 godina.",
  },
};

export const BENEFITS = [
  {
    icon: "Coins",
    title: { en: "Annual Yield", sr: "Godišnji prinos" },
    desc: {
      en: "65–70% of net rental income is distributed to token holders annually. Yield is calculated proportionally to tokens held.",
      sr: "65–70% neto prihoda od rentiranja raspoređuje se imaocima tokena jednom godišnje. Prinos se obračunava srazmerno broju tokena.",
    },
  },
  {
    icon: "Home",
    title: { en: "Priority Booking", sr: "Prioritetna rezervacija" },
    desc: {
      en: "Every year, reserve 4 weeks at 30–35% of the reference market rate. You choose the dates — the app confirms availability.",
      sr: "Svake godine rezervišite 4 nedelje boravka po 30–35% referentne tržišne cene. Vi birate termin — app potvrđuje dostupnost.",
    },
  },
  {
    icon: "Vote",
    title: { en: "Cooperative Membership", sr: "Članstvo u Zadruzi" },
    desc: {
      en: "Every holder automatically becomes a member of the Winfield Token Housing Cooperative (1 holder = 1 vote). Annual meeting, transparent financial reports.",
      sr: "Svaki imalac automatski postaje član Stambene zadruge Winfield Token (1 imalac = 1 glas). Godišnja skupština, transparentni finansijski izveštaji.",
    },
  },
  {
    icon: "Gift",
    title: { en: "Gift to Others", sr: "Poklonjivo" },
    desc: {
      en: "Gift stay weeks to friends, family or business partners. Your token — your choice of who uses it.",
      sr: "Poklonite nedelje boravka prijateljima, rodbini ili poslovnim partnerima. Vaš token — vaša odluka o tome ko ga koristi.",
    },
  },
  {
    icon: "Repeat",
    title: { en: "Location Exchange", sr: "Razmena lokacija" },
    desc: {
      en: "Exchange stays across other tokenised locations in the Winfield portfolio — same principles, different destinations. (In development)",
      sr: "Razmena boravka na drugim tokenizovanim lokacijama u Winfield portfoliju — isti principi, različite destinacije. (U razvoju)",
    },
  },
  {
    icon: "Scroll",
    title: { en: "Hereditary & Transferable", sr: "Nasledivo & Prenosivo" },
    desc: {
      en: "Rights pass to your heirs. The token is transferable to other verified (KYC) holders in accordance with the applicable rules and the Cooperative's bylaws.",
      sr: "Prava prelaze na naslednika. Token je prenosiv na druge verifikovane (KYC) imaoce u skladu sa važećim pravilima i pravilnikom Zadruge.",
    },
  },
];

// ---------- Partners ----------
export const PARTNERS_INTRO = {
  eyebrow: { en: "Real Estate Tokenisation Platform", sr: "Platforma za tokenizaciju nekretnina" },
  title: {
    en: "Winfield tokenises premium real estate",
    sr: "Winfield tokenizuje premium nekretnine",
  },
  description: {
    en: "Monte Casa I in Zlatibor is our first partner property — but not our last. Winfield is building a platform for tokenising premium real estate in attractive locations, following the same principles and holder protection standards.",
    sr: "Monte Casa I na Zlatiboru je naš prvi partnerski objekat — ali ne i jedini. Winfield gradi platformu za tokenizaciju premium nekretnina na atraktivnim lokacijama, po istim principima i istim standardima zaštite imaoca.",
  },
};

export const PARTNERS = [
  {
    status: { en: "ACTIVE · Pre-launch", sr: "AKTIVAN · Pre-launch" },
    active: true,
    name: {
      en: "Monte Casa I · Zlatibor, Serbia",
      sr: "Monte Casa I · Zlatibor",
    },
    desc: {
      en: "A luxury resort on Zlatibor mountain with indoor pool, SPA, reception and smart home system. Winfield is tokenising 2 units — a 58m² top-floor duplex (Apt. 129) and a 180m²+ penthouse (Apt. 141).",
      sr: "Luksuzni resort na Zlatiboru sa unutrašnjim bazenom, SPA, recepcijom i pametnim kućnim sistemom. Winfield tokenizuje 2 jedinice — duplex od 58m² na poslednjem spratu (stan 129) i penthaus preko 180m² (stan 141).",
    },
    amenities: [
      { en: "🏨 Reception & Lobby", sr: "🏨 Recepcija & Lobby" },
      { en: "🏊 Indoor Pool", sr: "🏊 Unutrašnji bazen" },
      { en: "🌡️ Tepidarium & Steam Bath", sr: "🌡️ Tepidarijum & Steam Bath" },
      { en: "🎮 Kids Playroom", sr: "🎮 Dečja igraonica" },
      { en: "🏠 Smart Home", sr: "🏠 Pametni dom" },
      { en: "🅿️ Parking", sr: "🅿️ Parking" },
    ],
  },
  {
    status: { en: "In preparation", sr: "U pripremi" },
    active: false,
    name: { en: "Future Partners", sr: "Naredni partneri" },
    desc: {
      en: "Premium mountain, coastal and urban destinations — same tokenisation model, same holder guarantees.",
      sr: "Premium planinska, primorska i gradska odmarališta — isti model tokenizacije, iste garancije za imaoce.",
    },
    amenities: [],
  },
];

// ---------- Packages ----------
export const PACKAGES_INTRO = {
  eyebrow: { en: "Monte Casa I — Packages", sr: "Monte Casa I — Paketi" },
  title: { en: "Choose your apartment", sr: "Izaberite svoj apartman" },
  description: {
    en: "Each package grants 4 weeks per year for 99 years in your chosen apartment.",
    sr: "Svaki paket daje pravo na 4 nedelje godišnje tokom 99 godina, u odabranom apartmanu.",
  },
};

export const PACKAGES = [
  {
    available: true,
    unit: "129",
    priceEur: 14900,
    badge: { en: "Standard · Available", sr: "Standard · Dostupno" },
    name: { en: "Apartment 129 — Top-floor Duplex", sr: "Stan 129 — Duplex na poslednjem spratu" },
    meta: [
      { en: "📐 58 m²", sr: "📐 58 m²" },
      { en: "🛏 2 bedrooms", sr: "🛏 2 spavaće sobe" },
      { en: "🚿 2 bathrooms", sr: "🚿 2 kupatila" },
    ],
    priceFromLabel: { en: "from", sr: "od" },
    features: [
      { en: "Top-floor duplex with open living, dining & kitchen", sr: "Duplex na poslednjem spratu s otvorenim boravkom, trpezarijom i kuhinjom" },
      { en: "2 bedrooms · 2 bathrooms · 2 terraces", sr: "2 spavaće sobe · 2 kupatila · 2 terase" },
      { en: "Views over the Zlatibor plateau", sr: "Pogled na Zlatiborsku visoravan" },
      { en: "€2,900 deposit · 24 × €500 / month · 396 $WINN", sr: "Depozit €2.900 · 24 × 500 € / mesec · 396 $WINN" },
    ],
    cta: { en: "Reserve Standard →", sr: "Rezervišite Standard →" },
  },
  {
    available: true,
    unit: "141",
    priceEur: 28900,
    badge: { en: "Premium · Available", sr: "Premium · Dostupno" },
    name: { en: "Apartment 141 — Penthouse", sr: "Stan 141 — Penthaus" },
    meta: [
      { en: "📐 180+ m²", sr: "📐 180+ m²" },
      { en: "🛏 3 bedrooms", sr: "🛏 3 spavaće sobe" },
      { en: "🖼 50 m² gallery", sr: "🖼 galerija 50 m²" },
    ],
    priceFromLabel: { en: "from", sr: "od" },
    features: [
      { en: "Over 180 m² across two levels", sr: "Preko 180 m² na dva nivoa" },
      { en: "3 bedrooms · bathroom + guest WC · open-plan living", sr: "3 spavaće sobe · kupatilo + gostinski WC · otvoren prostor" },
      { en: "4 loggias & a 50 m² gallery above the living space", sr: "4 lođe i galerija 50 m² iznad dnevnog boravka" },
      { en: "€4,900 deposit · 24 × €1,000 / month · 396 $WINN", sr: "Depozit €4.900 · 24 × 1.000 € / mesec · 396 $WINN" },
    ],
    cta: { en: "Reserve Premium →", sr: "Rezervišite Premium →" },
  },
];

// ---------- Process ----------
export const PROCESS_INTRO = {
  eyebrow: { en: "Process", sr: "Proces" },
  title: { en: "Four steps to your $WINN token", sr: "Četiri koraka do vašeg $WINN tokena" },
};

export const PROCESS_STEPS = [
  {
    n: "01",
    title: { en: "Reserve your spot", sr: "Rezervišite mesto" },
    desc: {
      en: "Leave your details. We will contact you within 24h to confirm and answer any questions.",
      sr: "Ostavite podatke. Kontaktiramo vas u roku od 24h da potvrdimo i odgovorimo na pitanja.",
    },
  },
  {
    n: "02",
    title: { en: "Sign the pre-agreement", sr: "Potpišite predugovor" },
    desc: {
      en: "Electronically — from anywhere. 5 minutes. In English or Serbian. Deposit refunded if KHoV does not approve.",
      sr: "Elektronski — odakle god. 5 minuta. Na srpskom ili engleskom. Depozit se vraća ako KHoV ne odobri emisiju.",
    },
  },
  {
    n: "03",
    title: { en: "Pay deposit + instalments", sr: "Platite depozit + rate" },
    desc: {
      en: "Pay the deposit via SEPA bank transfer (or card, where available). Monthly instalments follow only after KHoV approval. Simple and transparent.",
      sr: "Depozit plaćate SEPA transferom (ili karticom, gde je dostupno). Mesečne rate kreću tek po odobrenju KHoV. Jednostavno i transparentno.",
    },
  },
  {
    n: "04",
    title: { en: "Receive your tokens", sr: "Primite tokene" },
    desc: {
      en: "Upon regulatory approval from KHoV RS (~6 months), 396 $WINN tokens will be issued to your digital account.",
      sr: "Po regulatornoj saglasnosti KHoV RS (~6 meseci), 396 $WINN tokena biće izdate na vaš digitalni nalog.",
    },
  },
];

// ---------- Payment ----------
export const PAYMENT_INTRO = {
  eyebrow: { en: "Payment", sr: "Plaćanje" },
  title: { en: "Flexible payment options", sr: "Fleksibilne opcije plaćanja" },
};

export const PAYMENT_BLOCKS = [
  {
    value: "€2.900",
    label: { en: "Deposit", sr: "Depozit" },
    note: { en: "Upon signing the pre-agreement", sr: "Pri potpisivanju predugovora" },
  },
  {
    value: "24×€500",
    label: { en: "Monthly instalments", sr: "Mesečne rate" },
    note: { en: "Over 24 months (Standard)", sr: "Tokom 24 meseca (Standard)" },
  },
  {
    value: "€14.900",
    label: { en: "Total", sr: "Ukupno" },
    note: { en: "Standard — Apartment 129", sr: "Standard — Stan 129" },
    highlight: true,
  },
];

export const PAYMENT_METHODS = [
  {
    icon: "Landmark",
    title: { en: "SEPA Transfer", sr: "SEPA Transfer" },
    desc: {
      en: "NLB Komercijalna banka · EUR · SWIFT KOBBRSBG",
      sr: "NLB Komercijalna banka · EUR · SWIFT KOBBRSBG",
    },
  },
  {
    icon: "CreditCard",
    title: { en: "Card", sr: "Kartica" },
    desc: {
      en: "Visa / Mastercard · 3D Secure · Monri WSPay",
      sr: "Visa / Mastercard · 3D Secure · Monri WSPay",
    },
  },
];

export const PAYMENT_DISCLAIMER = {
  en: "The deposit is fully refunded if the Serbian Securities Commission does not approve the $WINN token issuance.",
  sr: "Depozit se u potpunosti vraća ako Komisija za hartije od vrednosti RS ne odobri emisiju $WINN tokena.",
};

// ---------- Gallery ----------
export const GALLERY_INTRO = {
  eyebrow: { en: "Gallery", sr: "Galerija" },
  title: { en: "Step inside Monte Casa.", sr: "Pogledajte Monte Casu." },
  description: {
    en: "The residence, apartments, and spa centre on Zlatibor — exactly as you'll experience them.",
    sr: "Rezidencija, apartmani i SPA centar na Zlatiboru — upravo onakvi kakve ćete ih doživeti.",
  },
};

export const GALLERY = [
  { src: "/img/gallery/exterior-1.jpg", caption: { en: "Monte Casa Zlatibor residence", sr: "Rezidencija Monte Casa Zlatibor" }, category: { en: "Exterior", sr: "Eksterijer" } },
  { src: "/img/gallery/living-1.jpg", caption: { en: "Living room — Type 1 apartment", sr: "Dnevni boravak — apartman Tip 1" }, category: { en: "Apartments", sr: "Apartmani" } },
  { src: "/img/gallery/pool.jpg", caption: { en: "Spa centre indoor pool", sr: "Unutrašnji bazen u SPA centru" }, category: { en: "Spa & Wellness", sr: "SPA i Wellness" } },
  { src: "/img/gallery/bedroom-1.jpg", caption: { en: "Bedroom — Type 1 apartment", sr: "Spavaća soba — apartman Tip 1" }, category: { en: "Apartments", sr: "Apartmani" } },
  { src: "/img/gallery/entrance.jpg", caption: { en: "Entrance to Monte Casa", sr: "Ulaz u Monte Casu" }, category: { en: "Exterior", sr: "Eksterijer" } },
  { src: "/img/gallery/sauna.jpg", caption: { en: "Sauna in the spa centre", sr: "Sauna u SPA centru" }, category: { en: "Spa & Wellness", sr: "SPA i Wellness" } },
  { src: "/img/gallery/living-2.jpg", caption: { en: "Living room — Type 2 apartment", sr: "Dnevni boravak — apartman Tip 2" }, category: { en: "Apartments", sr: "Apartmani" } },
  { src: "/img/gallery/tepidarium.jpg", caption: { en: "Tepidarium", sr: "Tepidarijum" }, category: { en: "Spa & Wellness", sr: "SPA i Wellness" } },
  { src: "/img/gallery/bedroom-2.jpg", caption: { en: "Bedroom — Type 2 apartment", sr: "Spavaća soba — apartman Tip 2" }, category: { en: "Apartments", sr: "Apartmani" } },
  { src: "/img/gallery/steam-bath.jpg", caption: { en: "Steam bath", sr: "Parno kupatilo" }, category: { en: "Spa & Wellness", sr: "SPA i Wellness" } },
  { src: "/img/gallery/lounge.jpg", caption: { en: "Spa lounge", sr: "SPA lounge" }, category: { en: "Amenities", sr: "Sadržaji" } },
  { src: "/img/gallery/playroom.jpg", caption: { en: "Children's playroom", sr: "Dečja igraonica" }, category: { en: "Amenities", sr: "Sadržaji" } },
  { src: "/img/gallery/exterior-2.jpg", caption: { en: "Approach to Monte Casa", sr: "Prilaz Monte Casi" }, category: { en: "Exterior", sr: "Eksterijer" } },
];

// ---------- Roadmap ----------
export const ROADMAP_INTRO = {
  eyebrow: { en: "Roadmap", sr: "Plan razvoja" },
  title: {
    en: "The journey to a regulated $WINN issuance.",
    sr: "Put do regulisane emisije $WINN tokena.",
  },
};

export const ROADMAP = [
  {
    phase: { en: "Phase 1", sr: "Faza 1" },
    title: { en: "Private Pre-Launch", sr: "Privatni Pre-Launch" },
    items: [
      { en: "Reservations open — limited spots, fully refundable deposit", sr: "Otvorene rezervacije — ograničen broj mesta, depozit u potpunosti povratan" },
      { en: "Electronic pre-agreement (English or Serbian)", sr: "Elektronski predugovor (na srpskom ili engleskom)" },
      { en: "Legal steps through which Winfield becomes the owner of, or contracts future ownership over, the properties concerned", sr: "Pravni koraci kojima Winfield postaje vlasnik ili ugovara budući svojinski status nad predmetnim nekretninama" },
      { en: "Founding of the Winfield Token Housing Cooperative", sr: "Osnivanje Stambene zadruge Winfield Token" },
    ],
  },
  {
    phase: { en: "Phase 2", sr: "Faza 2" },
    title: { en: "Regulatory Approval — KHoV RS", sr: "Regulatorna saglasnost — KHoV RS" },
    items: [
      { en: "White paper filed with the Serbian Securities Commission", sr: "Beli papir predat Komisiji za hartije od vrednosti RS" },
      { en: "Compliance and KYC/AML framework finalised (non-custodial architecture)", sr: "Završetak okvira usklađenosti i KYC/AML (nekastodijalna arhitektura)" },
      { en: "Independent property valuation & yield modelling", sr: "Nezavisna procena nekretnine i modeliranje prinosa" },
      { en: "White paper approval (first half of 2027)", sr: "Odobrenje belog papira (prva polovina 2027.)" },
    ],
  },
  {
    phase: { en: "Phase 3", sr: "Faza 3" },
    title: { en: "Token Issuance", sr: "Emisija tokena" },
    items: [
      { en: "396 $WINN tokens per package issued to holders' digital accounts (issuance schedule defined by the white paper)", sr: "396 $WINN tokena po paketu izdaje se na digitalne naloge imaoca (dinamika emisije definisana belim papirom)" },
      { en: "Smart-home and Cooperative app rolled out to holders", sr: "Smart-home i app Zadruge dostupni imaocima" },
      { en: "First annual cooperative assembly (1 holder = 1 vote)", sr: "Prva godišnja skupština Zadruge (1 imalac = 1 glas)" },
    ],
  },
  {
    phase: { en: "Phase 4", sr: "Faza 4" },
    title: { en: "Operations, Yield & Platform Growth", sr: "Operacije, prinos i rast platforme" },
    items: [
      { en: "Building occupancy permit — rental operations begin", sr: "Upotrebna dozvola — kreće rentiranje" },
      { en: "First annual yield distribution (65–70% of net rental income)", sr: "Prva godišnja isplata prinosa (65–70% neto prihoda od rentiranja)" },
      { en: "Location exchange feature live across the Winfield portfolio", sr: "Funkcija razmene lokacija u celom Winfield portfoliju" },
      { en: "Next partner properties teased — mountain, coast & urban", sr: "Najava narednih partnerskih nekretnina — planina, primorje i grad" },
    ],
  },
  {
    phase: { en: "Phase 5", sr: "Faza 5" },
    title: { en: "Luxury Portfolio Expansion", sr: "Širenje luksuznog portfolija" },
    items: [
      { en: "Acquisition of additional luxury units beyond the Monte Casa I series", sr: "Kupovina dodatnih luksuznih jedinica izvan serije Monte Casa I" },
      { en: "Expansion into new premium destinations & resort locations", sr: "Širenje na nove premium destinacije i odmarališta" },
      { en: "A new $WINN token series for each property added (same 396-token package model)", sr: "Nova serija $WINN tokena za svaku dodatu nekretninu (isti model paketa od 396 tokena)" },
      { en: "Reinvestment of proceeds to grow the portfolio & broaden rental yield for existing holders", sr: "Reinvestiranje sredstava radi rasta portfolija i šireg prinosa od rentiranja za postojeće imaoce" },
    ],
  },
];

// ---------- FAQ ----------
export const FAQ_INTRO = {
  eyebrow: { en: "FAQ", sr: "FAQ" },
  title: { en: "Questions & Answers", sr: "Pitanja i odgovori" },
};

export const FAQS = [
  {
    q: { en: "What is the $WINN token legally?", sr: "Šta je $WINN token pravno?" },
    a: {
      en: "A security/investment digital token subject to approval by the Securities Commission of the Republic of Serbia (KHoV). It grants the right to rental yield and priority booking. It does not represent property ownership.",
      sr: "Security/investicioni digitalni token uslovljen odobrenjem Komisije za hartije od vrednosti Republike Srbije (KHoV). Daje pravo na prinos od rentiranja i prioritetnu rezervaciju boravka. Ne predstavlja vlasništvo nad nekretninom.",
    },
  },
  {
    q: { en: "When do I start receiving yield?", sr: "Kada počinjem da primam prinos?" },
    a: {
      en: "Yield starts accruing once the building receives its occupancy permit and the Cooperative begins rental operations. Distribution is annual, proportional to tokens held.",
      sr: "Prinos počinje teći od momenta kada objekat dobije upotrebnu dozvolu i Zadruga počne sa rentiranjem. Isplata je jednom godišnje, srazmerno broju tokena.",
    },
  },
  {
    q: { en: "Can I give stay weeks to someone else?", sr: "Mogu li pokloniti nedelje boravka?" },
    a: {
      en: "Yes — you can gift stay weeks to a friend, family member or business partner. Manage bookings through the Winfield app.",
      sr: "Da — nedelje boravka možete pokloniti prijatelju, članu porodice ili poslovnom partneru. Koristite Winfield app za upravljanje rezervacijama.",
    },
  },
  {
    q: { en: "What if regulatory approval is not obtained?", sr: "Šta ako regulatorna saglasnost ne bude ishodovana?" },
    a: {
      en: "Your deposit is fully refunded — no questions asked. The pre-agreement clearly protects you. This is a reservation, not a final purchase.",
      sr: "Vaš depozit se u potpunosti vraća — bez pitanja. Predugovor vas jasno štiti. Ovo je rezervacija, ne konačna kupovina.",
    },
  },
  {
    q: { en: "Will there be other properties?", sr: "Hoće li biti i drugih objekata?" },
    a: {
      en: "Yes — Monte Casa I is our first partner property. Winfield is building a platform for tokenising premium real estate across multiple locations following the same principles.",
      sr: "Da — Monte Casa I je naš prvi partnerski objekat. Winfield gradi platformu za tokenizaciju premium nekretnina na različitim lokacijama po istim principima.",
    },
  },
  {
    q: { en: "What is the Winfield Token Housing Cooperative?", sr: "Šta je Stambena zadruga Winfield Token?" },
    a: {
      en: "The management body that administers the properties, organises rental and distributes income to token holders. Every holder automatically becomes a member with voting rights (1 member = 1 vote).",
      sr: "Upravljačko telo koje administrira nekretninama, organizuje rentiranje i raspoređuje prihode imaocima tokena. Svaki imalac automatski postaje član sa pravom glasa (1 član = 1 glas).",
    },
  },
];

// ---------- Final CTA / Reservation ----------
export const CTA = {
  title: {
    en: ["Secure your spot", "before the launch.", "Zlatibor."],
    sr: ["Osigurajte mesto", "pre javne ponude.", "Zlatibor."],
  },
  italicIndex: 2,
  bullets: [
    {
      en: "Pre-launch price — before the formal public offer",
      sr: "Pre-launch cena — pre formalne javne ponude",
    },
    {
      en: "Deposit refunded if KHoV does not approve issuance",
      sr: "Depozit se vraća ako KHoV ne odobri emisiju",
    },
    {
      en: "Electronic pre-agreement — sign in 5 minutes",
      sr: "Elektronski predugovor — potpišite za 5 minuta",
    },
    {
      en: "SEPA or card — pay from any bank",
      sr: "SEPA ili kartica — plaćate iz bilo koje banke",
    },
    {
      en: "Hereditary and transferable property rights",
      sr: "Nasledivo i prenosivo imovinsko pravo",
    },
  ],
  cta: { en: "Reserve your spot →", sr: "Rezervišite mesto →" },
  footnote: {
    en: "Limited availability · Monte Casa I, Zlatibor",
    sr: "Ograničen broj mesta · Monte Casa I, Zlatibor",
  },
};

export const RESERVATION_FORM = {
  eyebrow: { en: "Reservation", sr: "Rezervacija" },
  title: { en: "Leave your details", sr: "Ostavite svoje podatke" },
  description: {
    en: "We'll contact you within 24 hours to confirm and answer any questions.",
    sr: "Kontaktiramo vas u roku od 24h da potvrdimo i odgovorimo na pitanja.",
  },
  fields: {
    name: { en: "Full name", sr: "Ime i prezime" },
    email: { en: "Email", sr: "Email" },
    phone: { en: "Phone (optional)", sr: "Telefon (opciono)" },
    package: { en: "Preferred package", sr: "Željeni paket" },
    message: { en: "Message (optional)", sr: "Poruka (opciono)" },
  },
  packageOptions: [
    { value: "standard-129", label: { en: "Standard — Apartment 129 (€14,900)", sr: "Standard — Stan 129 (€14.900)" } },
    { value: "premium-141", label: { en: "Premium — Apartment 141 (€28,900)", sr: "Premium — Stan 141 (€28.900)" } },
    { value: "not-sure", label: { en: "Not sure yet — please advise", sr: "Još nisam siguran — savetujte me" } },
  ],
  submit: { en: "Send reservation", sr: "Pošalji rezervaciju" },
  submitting: { en: "Sending…", sr: "Šalje se…" },
  success: {
    en: "Thank you. We'll be in touch within 24 hours.",
    sr: "Hvala vam. Kontaktiramo vas u roku od 24h.",
  },
  error: {
    en: "Something went wrong. Please email us at winfieldtoken@gmail.com.",
    sr: "Došlo je do greške. Pišite nam na winfieldtoken@gmail.com.",
  },
  mailtoFallback: {
    en: "Prefer email? Write to",
    sr: "Više vam odgovara email? Pišite na",
  },
};

// ---------- Package configuration ----------
// Per-batch values. Update when a new property batch goes live.
// Formula:
//   deposit            = price − (monthlyInstallment × installmentCount)
//   total              = price
//   tokensPerPackage   = 396 (fixed across batches)
//
// Display rule: the package PRICE / DEPOSIT / INSTALMENTS belong to a
// specific property batch. On the homepage, show only "from €X" or a
// general description. The full numbers live on the property/offering page.
export const PACKAGE_CONFIG = {
  price: 14900,             // EUR — Standard (Apartment 129)
  monthlyInstallment: 500,  // EUR — Standard
  installmentCount: 24,     // months
  tokensPerPackage: 396,    // tokens (fixed)
  currency: "EUR",
  currencySymbol: "€",
};

export const computePackageNumbers = (cfg = PACKAGE_CONFIG) => {
  const deposit = cfg.price - cfg.monthlyInstallment * cfg.installmentCount;
  return {
    price: cfg.price,
    deposit,
    monthlyInstallment: cfg.monthlyInstallment,
    installmentCount: cfg.installmentCount,
    tokensPerPackage: cfg.tokensPerPackage,
  };
};

// EU-style number formatter: 14400 -> "14.400"
export const formatEUR = (n) =>
  new Intl.NumberFormat("de-DE", { maximumFractionDigits: 0 }).format(n);

export const FOOTER = {
  tagline: {
    en: "Winfield Inženjering doo Užice — tokenising premium real estate on Zlatibor and beyond, with the Winfield Token ($WINN).",
    sr: "Winfield Inženjering doo Užice — tokenizacija premium nekretnina na Zlatiboru i šire, kroz Winfield Token ($WINN).",
  },
  exploreLabel: { en: "Explore", sr: "Istražite" },
  communityLabel: { en: "Community", sr: "Zajednica" },
  copyright: {
    en: "Winfield Inženjering doo Užice, Serbia. All rights reserved.",
    sr: "Winfield Inženjering doo Užice, Srbija. Sva prava zadržana.",
  },
  disclaimer: {
    en: "$WINN is a security token subject to approval by the Serbian Securities Commission. Not financial advice.",
    sr: "$WINN je security token uslovljen odobrenjem Komisije za hartije od vrednosti RS. Nije finansijski savet.",
  },
  persistentDisclaimer: {
    en: "This website is for informational purposes only and does not constitute a financial offer or investment advice. $WINN is a security/investment digital token; its issuance is subject to approval by the Securities Commission of the Republic of Serbia (KHoV). Any pre-agreement deposit is fully refundable if approval is not obtained.",
    sr: "Ovaj sajt je isključivo informativnog karaktera i ne predstavlja finansijsku ponudu niti investicioni savet. $WINN je security/investicioni digitalni token; njegova emisija je uslovljena odobrenjem Komisije za hartije od vrednosti Republike Srbije (KHoV). Svaki avans po predugovoru je u celosti povratan ukoliko odobrenje ne bude izdato.",
  },
};
